import React from 'react';
import Typography from '@material-ui/core/Typography';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { colors } from '../../../themes/colors';
import { PsychiatryVisitsCompletedNode } from '../../../generated/webapp_gql';

const styles = () =>
  createStyles({
    visitsDataBorderRight: {
      borderRight: `1px solid ${colors.gray1}`,
    },
    visitsData: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: '16px 0',
      flexGrow: 1,
    },
    visitsDataTop: {
      fontFamily: 'Avenir-Black',
      fontSize: 24,
      color: colors.black3,
    },
    visitsDataMiddle: {
      fontFamily: 'Avenir-Black',
      fontSize: 14,
      color: colors.black3,
    },
    visitsDataBottom: {
      fontFamily: 'Avenir-Medium',
      fontSize: 12,
      color: colors.gray11,
    },
    visitsRow: {
      display: 'flex',
    },
  });

type Props = WithStyles<typeof styles> & {
  visitsCompleted: PsychiatryVisitsCompletedNode;
};

const PsychiatrySessionsInfoSection: React.FC<Props> = ({ classes, visitsCompleted }) => {
  return (
    <div className={classes.visitsRow}>
      <div className={classNames(classes.visitsData, classes.visitsDataBorderRight)}>
        <Typography className={classes.visitsDataTop}>
          {visitsCompleted?.initialEvaluationVisitsCompleted || 0}
        </Typography>

        <Typography className={classes.visitsDataMiddle}>Initial Evaluation Sessions</Typography>

        <Typography className={classes.visitsDataBottom}>completed</Typography>
      </div>

      <div className={classes.visitsData}>
        <Typography className={classes.visitsDataTop}>
          {visitsCompleted?.followUpVisitsCompleted || 0}
        </Typography>

        <Typography className={classes.visitsDataMiddle}>Follow-up Sessions</Typography>

        <Typography className={classes.visitsDataBottom}>completed</Typography>
      </div>
    </div>
  );
};

export default withStyles(styles)(PsychiatrySessionsInfoSection);
